import { api } from '../config/api';

export interface Category {
  id: number;
  name: string;
  type: string;
  parent_id?: number;
  is_active: boolean;
  color_code?: string;
  icon?: string;
  created_at: string;
  updated_at?: string;
}

class CategoriesService {
  async getCategories(type?: string): Promise<Category[]> {
    const params = type ? { type } : {};
    const response = await api.get('/categories/', { params });
    return response.data;
  }

  async getExpenseCategories(): Promise<Category[]> {
    return this.getCategories('expense');
  }
}

export const categoriesService = new CategoriesService();